export default "__VITE_ASSET__BVIePn5E__"